import React from 'react';
import type { IconProps } from '@frameio/vapor-icons';

export const buttonIconSizes = {
  small: 16,
  regular: 24,
} as const;

type ButtonIconProps = {
  size: 'small' | 'regular';
  icon?: React.ReactElement<IconProps>;
};

export function ButtonIcon({ size, icon }: ButtonIconProps) {
  if (icon && React.isValidElement(icon)) {
    return React.cloneElement(icon as any, {
      size: buttonIconSizes[size],
      'aria-hidden': true,
      ...(icon.props || {}),
    });
  }

  return null;
}
